import { createContext, useContext } from 'react';

import type { FindingSource } from 'modules/common/viewer/pdfViewer/flyout/types';

export type ExtractionVisibilityState = {
  showAllExtractions: boolean;
  whiteoutCategories: Set<string>;
  /**
   * Maps every annotation ID (including GROUP_ANNOTATION_ID_PREFIX + calloutGroupId for
   * grouped callouts) to all the findings it represents. Covers PartBotResultJson (Found
   * in Files), PrintExtraction (Reqs Review), field suggestions, extracted tables, and
   * text extractions. Used by the suggestion annotation flyout to list findings for a
   * focused annotation.
   */
  annotationFindingsIndex: Map<string, FindingSource[]>;
};

export type ExtractionVisibilityActions = {
  toggleShowAllExtractions: () => void;
  toggleWhiteoutCategory: (category: string) => void;
};

export type ExtractionVisibilityContextValue = {
  state: ExtractionVisibilityState;
  actions: ExtractionVisibilityActions;
};

export const ExtractionVisibilityContext =
  createContext<ExtractionVisibilityContextValue | null>(null);
ExtractionVisibilityContext.displayName = 'ExtractionVisibilityContext';

export function useExtractionVisibility(): ExtractionVisibilityContextValue {
  const context = useContext(ExtractionVisibilityContext);
  if (context == null) {
    throw new Error(
      'useExtractionVisibility must be used within a provider that supplies ExtractionVisibilityContext',
    );
  }
  return context;
}
